export default "__VITE_ASSET__2e2f6937__"